import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-script-code.svg?component
var programming_script_code_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_script_code_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M7.8 4.6 1.4 11c-.6.6-.6 1.6 0 2l6.2 6.2m8.6-14.6 6.2 6.2c.6.6.6 1.6 0 2l-6.2 6.6"
	}, null, -1)])]);
}
var programming_script_code_default = { render: render$1 };
//#endregion
export { programming_script_code_default as default, programming_script_code_exports, render$1 as render };

//# sourceMappingURL=programming-script-code.svg.virtual.js.map